var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",staticClass:"quick-shop-modal",attrs:{"closeable":true,"removeOnClose":""}},[(_vm.loaded)?_c('quick-shop-Content',{attrs:{"product":_vm.product}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }